import {Pipe, PipeTransform} from '@angular/core';

@Pipe ({
  name: 'dayofweekmap'
})
export class DayOfWeekMapperPipe implements PipeTransform {
  transform(value: any, limit?: number) {
    if (value != null && value === '0') {
      return 'Monday';
    }
    if (value != null && value === '1') {
      return 'Tuesday';
    }
    if (value != null && value === '2') {
      return 'Wednesday';
    }
    if (value != null && value === '3') {
      return 'Thursday';
    }
    if (value != null && value === '4') {
      return 'Friday';
    }
    if (value != null && value === '5') {
      return 'Saturday';
    }
    if (value != null && value === '6') {
      return 'Sunday';
    }
    return value;
  }
}
